import { useContext } from 'react'
import { CAI_CHAT_FLOWS } from 'src/constants/cai-chat.constant'
import { streamPrompt } from '../utils/platform'
import { NotificationContext } from 'src/context/NotificationContext'

const useStreamPrompt = (chatReducer, onAwaitingResponseChange, translate) => {
  const { setIsTokenAvailable } = useContext(NotificationContext)

  const onStreamResponse = (data, flow) => {
    const { canvas, response, references } = data || {}
    if (
      canvas &&
      (flow === CAI_CHAT_FLOWS.FEEDBACK || flow === CAI_CHAT_FLOWS.GOALS)
    ) {
      onAwaitingResponseChange(false)
      chatReducer(
        {
          type: 'UPDATE_CANVAS',
          payload: { response: canvas },
        },
        flow,
      )
      return
    }

    if (!response) return
    chatReducer(
      {
        type: 'UPDATE_LAST_MESSAGE',
        payload: { response, references },
      },
      flow,
    )
  }

  const onStreamOpen = (flow) =>
    chatReducer({ type: 'INIT_RESPONSE', payload: {} }, flow)

  const onStreamEnd = () => onAwaitingResponseChange(false)

  const sendStreamPrompt = async (
    auth,
    roleName,
    scope,
    attachmentsId,
    chatId,
    message,
    hidden,
    messageContext,
    flow,
    endpoint,
    userId,
    organizationId,
    canvas,
    locale,
  ) => {
    try {
      onAwaitingResponseChange(true)
      await streamPrompt(
        (data) => onStreamResponse(data, flow),
        () => onStreamOpen(flow),
        onStreamEnd,
        auth?.token,
        roleName,
        scope,
        attachmentsId,
        chatId,
        message,
        hidden,
        messageContext,
        endpoint,
        userId,
        organizationId,
        canvas,
        translate,
        setIsTokenAvailable,
        locale,
      )
    } catch (e) {
      console.log(e)
      throw e
    } finally {
      onAwaitingResponseChange(false)
    }
  }

  return { sendStreamPrompt }
}

export default useStreamPrompt
//
